import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';

import {
    mcpUserEntitlementsStateActions,
    mcpUserEntitlementsStateSelector,
} from '../slices/mcp-user-entitlements-state.slice';

import type {SortDirection} from 'src/openapi/admin/models/SortDirection';

export const McpUserResourceNameHeader = () => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(mcpUserEntitlementsStateSelector);

    const sort = useCallback((direction: ('ASC' | 'DESC')) => {
        const sortCriteria = {
            direction: direction as SortDirection,
            field: undefined,
        };

        dispatch(mcpUserEntitlementsStateActions.setSortCriteria(sortCriteria));
    }, [dispatch]);

    return (
        <SortHeaderWithDataTable
            defaultDirection={SortDirections.ASC}
            direction={cacheKeys.sortCriteria.direction}
            filterActive={true}
            caption="Role/Resource"
            onSort={sort}
        />
    );
};
